// extracted by mini-css-extract-plugin
export default {"input-small-group":"InputGroup_input-small-group__6goJk","input-small":"InputGroup_input-small__x-SdV","error":"InputGroup_error__1SRzc"};